/**
 * AiProvenanceBadge
 * -----------------
 * Small footer badge declaring AI assistance + human review on generated
 * content. Helps with EU AI Act transparency, C2PA-readiness, and reduces
 * shadowban risk on platforms that downrank undisclosed AI content.
 */

import { Sparkles, ShieldCheck } from "lucide-react";

interface Props {
  reviewedBy?: string | null;
  className?: string;
}

export function AiProvenanceBadge({ reviewedBy, className = "" }: Props) {
  return (
    <div
      className={`inline-flex items-center gap-2 rounded-full border border-border bg-muted/30 px-3 py-1.5 text-[11px] text-muted-foreground ${className}`}
      title="This page was generated with AI assistance and reviewed by a human editor. See our Editorial Standards page for our review process."
    >
      <Sparkles className="h-3 w-3 text-primary" aria-hidden="true" />
      <span>AI-Assisted</span>
      <span aria-hidden="true">·</span>
      <ShieldCheck className="h-3 w-3 text-primary" aria-hidden="true" />
      <span>Human-Reviewed{reviewedBy ? ` by ${reviewedBy}` : ""}</span>
    </div>
  );
}
